import { createElement } from 'react';

import type { IconProps } from '../icon/icon';
import { Icon } from '../icon/icon'; // props is just passed in to keep variables.jsx happy. We don’t use variables.props
const SvgInfoIcon = (componentProps: IconProps, props = {}) => {
  return createElement(
    Icon,
    componentProps,
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 32 32"
      {...props}
    >
      <path
        fill="#353C4A"
        fillRule="evenodd"
        d="M16 27c6.075 0 11-4.925 11-11S22.075 5 16 5 5 9.925 5 16s4.925 11 11 11m0 2c7.18 0 13-5.82 13-13S23.18 3 16 3 3 8.82 3 16s5.82 13 13 13"
        clipRule="evenodd"
      />
      <path
        fill="#353C4A"
        fillRule="evenodd"
        d="M17 14v8h-2v-8z"
        clipRule="evenodd"
      />
      <circle
        cx={16}
        cy={10.5}
        r={1.5}
        fill="#353C4A"
        transform="rotate(180 16 10.5)"
      />
    </svg>,
  );
};
export default SvgInfoIcon;
